import { render, staticRenderFns } from "./ViewDashboardNew.vue?vue&type=template&id=6785f58b"
import script from "./ViewDashboardNew.vue?vue&type=script&lang=js"
export * from "./ViewDashboardNew.vue?vue&type=script&lang=js"
import style0 from "./ViewDashboardNew.vue?vue&type=style&index=0&id=6785f58b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports